module.exports = __webpack_public_path__ + "img/2.4d13375c.jpg";